import { LuggageCardRow } from '@design-system/components/molecules/luggage-card/entities/luggage-card.types';
import {
  PriceDetailCardSubtitle, PriceDetailCardPrice, PriceDetailCardDiscount
} from '@design-system/components/organisms/price-detail-card/entities/price-detail-card.types';

export enum TooltipType {
  Text = 'text',
  Price = 'price',
  Luggage = 'luggage',
}

export enum TooltipDisplay {
  Auto = 'Auto',
  Click = 'Click',
  Sticky = 'Sticky'
}

export enum TooltipPosition {
  Above = 'above',
  Below = 'below',
  Left = 'left',
  Right = 'right',
}

export type TooltipTextAlign = 'center' | 'left' | 'right';

export interface TooltipPriceConfig {
  title: string;
  subtitles: PriceDetailCardSubtitle[];
  rows: PriceDetailCardPrice[][];
  discount: PriceDetailCardDiscount;
  total: PriceDetailCardPrice;
}

export interface TooltipLuggageConfig {
  title: string;
  rows: LuggageCardRow[];
}

export const TooltipDefaultValues = {
  Type: TooltipType.Text,
  Display: TooltipDisplay.Auto,
  Position: TooltipPosition.Above,
  TextAlign: 'center' as TooltipTextAlign,
  Visible: true,
}
